/**
 * The lane this browser is looking at (M46): the real System or the demo
 * group. Only accounts that can see both ever choose; the choice is a
 * per-browser convenience, so it lives in localStorage and every read of it
 * survives a blocked or empty store.
 */
const KEY = 'attest.lane';

export function getLane() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function setLane(id) {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    /* the server falls back to the first real lane */
  }
}

/** Add ?tenant=<lane> to an API path when a lane has been chosen. */
export function withLane(path) {
  const lane = getLane();
  if (!lane) return path;
  return `${path}${path.includes('?') ? '&' : '?'}tenant=${encodeURIComponent(lane)}`;
}

export default { getLane, setLane, withLane };
